import React, { useState } from "react";
import { apiFetch } from "../../../../apiFetch";
import "./ManageUserStatus.css";


const ManageUserStatus = () => {
    const [searchValue, setSearchValue] = useState("");
    const [loading, setLoading] = useState(false);

    const [userData, setUserData] = useState(null);
    const [statusMessage, setStatusMessage] = useState("");

    // ✅ Fetch user status by login email
    const handleSearch = async () => {
        if (!searchValue.trim()) {
            setStatusMessage("Please enter a login email.");
            return;
        }

        setLoading(true);
        setStatusMessage("");
        setUserData(null);

        try {
            const res = await apiFetch(
                `/api/admin/all-users/by-email/${encodeURIComponent(searchValue.trim())}`
            );



            const data = await res.json();

            if (!res.ok) {
                setStatusMessage(data.message || "User not found.");
                return;
            }

            setUserData(data);
            setStatusMessage("User found ✅");
        } catch (err) {
            console.error(err);
            setStatusMessage("Server error. Could not fetch user status.");
        } finally {
            setLoading(false);
        }
    };

    // ✅ Update user status (Enable / Disable)
    const updateUserStatus = async (isDisabled) => {
        if (!userData?.firebaseUid) {
            setStatusMessage("Search a user first.");
            return;
        }

        setLoading(true);
        setStatusMessage("");

        try {
            const uid = (userData.firebaseUid || "").trim();

            const res = await apiFetch(
                `/api/admin/all-users/status/${encodeURIComponent(uid)}`,
                {
                    method: "PATCH",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ isDisabled }),
                }
            );




            const data = await res.json();

            if (!res.ok) {
                setStatusMessage(data.message || "Failed to update user status.");
                return;
            }

            setUserData((prev) => ({
                ...prev,
                isDisabled: data.isDisabled,
            }));

            setStatusMessage(
                data.isDisabled
                    ? "User has been DISABLED ⛔"
                    : "User has been ENABLED ✅"
            );
        } catch (err) {
            console.error(err);
            setStatusMessage("Server error. Could not update user status.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="manage-user-status-page">
            <div className="manage-user-status-header">
                <h2 className="manage-user-status-title">Manage User Status</h2>
                <p className="manage-user-status-subtitle">
                    Enable or disable user accounts from the Admin Dashboard.
                </p>
            </div>

            <div className="manage-user-status-card">
                <div className="manage-user-status-search">
                    <label className="manage-user-status-label">
                        Search User (Login Email)
                    </label>

                    <div className="manage-user-status-search-row">
                        <input
                            type="text"
                            placeholder="Enter login email here..."
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                            className="manage-user-status-input"
                        />

                        <button
                            className="manage-user-status-btn manage-user-status-btn--search"
                            onClick={handleSearch}
                            disabled={loading}
                        >
                            {loading ? "Loading..." : "Search"}
                        </button>
                    </div>

                    {statusMessage && (
                        <p className="manage-user-status-message">{statusMessage}</p>
                    )}
                </div>

                <div className="manage-user-status-user-preview">
                    <div className="manage-user-status-user-row">
                        <span className="manage-user-status-user-key">Login Email:</span>
                        <span className="manage-user-status-user-value">
                            {userData?.loginEmail || "(none)"}
                        </span>
                    </div>

                    <div className="manage-user-status-user-row">
                        <span className="manage-user-status-user-key">Firebase UID:</span>
                        <span className="manage-user-status-user-value">
                            {userData?.firebaseUid || "(none)"}
                        </span>
                    </div>

                    <div className="manage-user-status-user-row">
                        <span className="manage-user-status-user-key">Role:</span>
                        <span className="manage-user-status-user-value">
                            {userData?.role || "(none)"}
                        </span>
                    </div>

                    <div className="manage-user-status-user-row">
                        <span className="manage-user-status-user-key">Status:</span>
                        <span className="manage-user-status-user-value">
                            {userData
                                ? userData.isDisabled
                                    ? "Disabled ⛔"
                                    : "Active ✅"
                                : "(none)"}
                        </span>
                    </div>
                </div>

                <div className="manage-user-status-actions">
                    <button
                        className="manage-user-status-btn manage-user-status-btn--enable"
                        onClick={() => updateUserStatus(false)}
                        disabled={loading || !userData}
                    >
                        Enable
                    </button>

                    <button
                        className="manage-user-status-btn manage-user-status-btn--disable"
                        onClick={() => updateUserStatus(true)}
                        disabled={loading || !userData}
                    >
                        Disable
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ManageUserStatus;



